import React from "react";
import { Props } from "./types";

function TaskListIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <rect x="2" y="5" width="5" height="5" rx="1" />
      <polyline points="3.5 7.5 4.5 8.5 6.5 6.5" />
      <rect x="2" y="14" width="5" height="5" rx="1" />
      <line x1="10" y1="7.5" x2="21" y2="7.5" />
      <line x1="10" y1="16.5" x2="21" y2="16.5" />
    </svg>
  );
}

export { TaskListIcon };
